// extracted by mini-css-extract-plugin
module.exports = {"seasons":"Seasons_seasons__fo_id","title":"Seasons_title__1YtCh"};